<template>
    <router-view />
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'App'
});
</script>

<style>
@import 'video.js/dist/video-js.css';
@import './assets/css/player.css';
@import './assets/css/responsive_player.css'; 
@import './assets/css/richmedia.css'; 

</style>
